import { sessionManager } from "../context/sessionManager";

export const addCompanyDetails = async (customerData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "addCompanyDetails", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...customerData })
    });
    const jsonResponse = await response.json();

    if (jsonResponse?.success === true) {
        let data = customerData;
        data.id = jsonResponse?.data?.id;
        jsonResponse.data = data;
    }
    console.log('Add Customer Response:', jsonResponse);
    return jsonResponse;
};
export const login = async (email, password) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "getCompanyDetails", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, filterBy: "email", filterValue: email })
    });
    console.log('Login Response:', response);
    let jsonResponse = await response.json();
    console.log('Login JSON Response:', jsonResponse);

    if (jsonResponse?.success === true) {
        const companyData = jsonResponse?.data?.[0];
        console.log('Fetched Company Data:', companyData);
        if (companyData.password === password) {
            // Password matches, create session
            sessionManager.createSession({ id: companyData.id, email: companyData.email, name: companyData.name });
            return { success: true, data: companyData };
        } else {
            return { success: false, error: "Invalid password" };
        }
    } else {
        return { success: false, error: "User not found" };
    }
};
export const updatePassword = async (email, password) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "updateCompanyDetails", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, filterBy: "email", filterValue: email })
    });
    console.log('Login Response:', response);
    let jsonResponse = await response.json();
    console.log('Login JSON Response:', jsonResponse);

    if (jsonResponse?.success === true) {
        const companyData = jsonResponse?.data?.[0];
        console.log('Fetched Company Data:', companyData);
        if (companyData.password === password) {
            // Password matches, create session
            sessionManager.createSession({ id: companyData.id, email: companyData.email, name: companyData.name });
            return { success: true, data: companyData };
        } else {
            return { success: false, error: "Invalid password" };
        }
    } else {
        return { success: false, error: "User not found" };
    }
};
export const getCompanyDetails = async (filters = {}) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({
            action: "getCompanyDetails",
            apiKey: process.env.REACT_APP_API_KEY,
            origin: window.location.origin,
            ...filters
        })
    });
    const jsonResponse = await response.json();
    console.log('Get Company Details Response:', jsonResponse);
    return jsonResponse;
};

export const updateCompanyDetails = async (id, companyData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({
            action: "updateCompanyDetails",
            apiKey: process.env.REACT_APP_API_KEY,
            origin: window.location.origin,
            id: id,
            ...companyData
        })
    });
    const jsonResponse = await response.json();
    console.log('Update Company Details Response:', jsonResponse);

    if (jsonResponse?.success === true) {
        let data = { ...companyData, id: id };
        jsonResponse.data = data;
    }
    return jsonResponse;
};
export const sendPasswordResetOtp = async (email) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({
            action: "sendPasswordResetOtp",
            apiKey: process.env.REACT_APP_API_KEY,
            origin: window.location.origin,
            email: email
        })
    });
    const jsonResponse = await response.json();
    console.log('Send Password Reset OTP Response:', jsonResponse);
    return jsonResponse;
};

export const verifyPasswordResetOtp = async (email, otp) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({
            action: "verifyPasswordResetOtp",
            apiKey: process.env.REACT_APP_API_KEY,
            origin: window.location.origin,
            email: email,
            otp: otp
        })
    });
    const jsonResponse = await response.json();
    console.log('Verify Password Reset OTP Response:', jsonResponse);
    return jsonResponse;
};

export const resetPassword = async (email, newPassword) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({
            action: "resetPassword",
            apiKey: process.env.REACT_APP_API_KEY,
            origin: window.location.origin,
            email: email,
            newPassword: newPassword
        })
    });
    const jsonResponse = await response.json();
    console.log('Reset Password Response:', jsonResponse);
    return jsonResponse;
};
